export const plazaSSPListId = 'plaza_sessions';
export const SET_SELECTED_DEMO_CHARGERS = 'SET_SELECTED_DEMO_CHARGERS';
